package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.BlockW500Rounded: ImageVector
    get() {
        if (_blockW500Rounded != null) {
            return _blockW500Rounded!!
        }
        _blockW500Rounded = Builder(name = "BlockW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(320.89f, 855.91f)
                quadToRelative(-74.43f, -32.21f, -129.63f, -87.41f)
                quadToRelative(-55.19f, -55.2f, -87.29f, -129.72f)
                quadToRelative(-32.1f, -74.52f, -32.1f, -159.26f)
                quadToRelative(0.0f, -84.59f, 32.14f, -158.98f)
                quadToRelative(32.14f, -74.4f, 87.23f, -129.43f)
                quadToRelative(55.1f, -55.04f, 129.58f, -87.14f)
                quadToRelative(74.48f, -32.1f, 159.17f, -32.1f)
                quadToRelative(84.68f, 0.0f, 159.17f, 32.1f)
                quadToRelative(74.49f, 32.1f, 129.59f, 87.14f)
                quadToRelative(55.1f, 55.03f, 87.24f, 129.43f)
                quadToRelative(32.14f, 74.39f, 32.14f, 158.98f)
                quadToRelative(0.0f, 84.74f, -32.1f, 159.26f)
                reflectiveQuadTo(768.74f, 768.5f)
                quadToRelative(-55.2f, 55.2f, -129.65f, 87.41f)
                quadToRelative(-74.46f, 32.22f, -159.11f, 32.22f)
                quadToRelative(-84.65f, 0.0f, -159.09f, -32.22f)
                close()
                moveTo(480.0f, 797.13f)
                quadToRelative(52.09f, 0.0f, 100.65f, -16.3f)
                quadToRelative(48.57f, -16.31f, 89.13f, -48.11f)
                lineTo(226.8f, 289.98f)
                quadToRelative(-31.32f, 41.04f, -47.63f, 89.37f)
                quadToRelative(-16.3f, 48.32f, -16.3f, 100.17f)
                quadToRelative(0.0f, 132.81f, 92.28f, 225.21f)
                reflectiveQuadTo(480.0f, 797.13f)
                close()
                moveTo(733.43f, 669.07f)
                quadToRelative(31.09f, -41.05f, 47.4f, -89.37f)
                quadToRelative(16.3f, -48.33f, 16.3f, -100.18f)
                quadToRelative(0.0f, -132.6f, -92.28f, -224.62f)
                quadToRelative(-92.28f, -92.03f, -224.85f, -92.03f)
                quadToRelative(-51.85f, 0.0f, -100.05f, 16.06f)
                quadToRelative(-48.21f, 16.07f, -89.25f, 47.16f)
                lineToRelative(442.73f, 442.98f)
                close()
                moveTo(480.0f, 479.52f)
                close()
            }
        }
        .build()
        return _blockW500Rounded!!
    }

private var _blockW500Rounded: ImageVector? = null
